// Fresh mock data based on competitive analysis insights

export const heroData = {
  overtitle: "Atlanta's Leading Regenerative Medicine Clinic",
  headline: "Regenerative Medicine & Non-Surgical Pain Relief in Atlanta, GA",
  subheadline: "Non-surgical regenerative treatments that get to the source of your pain—so you can return to the life you love.",
  primaryCTA: "Book an Appointment",
  secondaryCTA: "Call (404) 355-2728",
  quizCTA: "Am I a Candidate?",
  heroImage: "/webp-images/hero-image.webp",
  trustBadges: [
    { icon: "Award", label: "Board Certified", value: "Physicians" },
    { icon: "Calendar", label: "Since", value: "2011" },
    { icon: "MapPin", label: "6+", value: "Locations" },
    { icon: "Users", label: "10,000+", value: "Patients Treated" }
  ]
};

export const trustBar = {
  stats: [
    { number: "14+", label: "Years of Excellence" },
    { number: "10,000+", label: "Successful Treatments" },
    { number: "6", label: "Convenient Locations" },
    { number: "100%", label: "Non-Surgical" }
  ]
};

export const services = [
  {
    id: 1,
    icon: "Sparkles",
    title: "Regenerative Medicine",
    description: "Advanced stem cell therapy and PRP treatments to promote natural healing and tissue repair.",
    features: ["Stem Cell Therapy", "PRP Injections", "Tissue Regeneration"],
    image: "/webp-images/Regenerative-Medicine.webp",
    fullDescription: "Regenerative medicine is focused on developing and applying new treatments to heal tissues and organs and restore function lost due to aging, disease, damage, or defects.",
    detailedInfo: "ARMI offers a multitude of innovative procedures to address spine and joint conditions by using a patient's own blood products, including platelet-rich plasma and stem cells, to stimulate healing. These non-surgical and minimally invasive procedures are done using advanced image-guidance to ensure targeted and precise treatments.",
    commonConditions: "We treat a variety of conditions with regenerative medicine, with low back pain, shoulder pain, and knee pain being the most common."
  },
  {
    id: 2,
    icon: "Activity",
    title: "Interventional Spine Medicine",
    description: "Comprehensive non-surgical spine treatments for neck and back pain relief.",
    features: ["Epidural Injections", "Facet Joint Injections", "Medial Branch Blocks", "Radiofrequency Neurotomy", "Trigger Point Injections"],
    image: "/webp-images/Interventional-Spine-Medicine.webp",
    fullDescription: "Here at ARMI, we specialize in a number of spine procedures, which we perform with either X-ray or ultrasound guidance. These treatments have been proven to effectively treat many spine conditions.",
    detailedInfo: "Whether you are experiencing neck pain, low back pain, or nerve pain traveling down your arms or legs, the physician at ARMI performs a variety of injection therapies to get you back on track."
  },
  {
    id: 3,
    icon: "Heart",
    title: "Orthopedic Care",
    description: "Non-surgical solutions for joint pain, arthritis, and sports injuries.",
    features: ["Shoulder Pain", "Knee Pain", "Hip Pain", "Wrist Pain", "Elbow Pain", "Ankle Pain"],
    image: "/webp-images/Orthopedic-Care.webp",
    fullDescription: "Orthopedic is defined as \"The branch of medicine that deals with the treatment of disorders or injuries of the bones, joints, and associated muscles.\"",
    detailedInfo: "The physician, at ARMI, specializes in the non-surgical treatment of bones, joints, and muscles. We first establish a treatment plan based on aggressively diagnosing the condition, the proceed through the treatment plan to achieve desired pain relief.",
    commonConditions: "We utilize image-guided injections for treatment of orthopedic complaints, including shoulder pain, knee pain, hip pain, wrist pain, elbow pain, and ankle pain."
  },
  {
    id: 4,
    icon: "Shield",
    title: "Personal Injury Care",
    description: "Specialized treatment for auto accidents and workplace injuries.",
    features: ["Auto Accident Care", "Workers Comp", "Attorney Referrals"],
    image: "/webp-images/Personal-Injury-Care.webp",
    fullDescription: "Personal Injury and Auto Accident Care",
    detailedInfo: "At ARMI, we understand the pain, hurt, trauma, and life disruption that an automobile accident can cause. We take great pains to make sure that all our patients, including patients who have been in an auto accident, are seen quickly and receive a high level of medical treatment.",
    commonConditions: "We know that car accident victims have a lot of stuff going on, and we make sure that we do not provide additional hassle. We get you in, get you better, and get you going."
  }
];

export const whyChooseATLREGEN = {
  overtitle: "Why Patients Choose ATLREGEN",
  headline: "Your Path to Pain-Free Living",
  subheadline: "We take a different approach—treating the source of your pain, not just the symptoms.",
  reasons: [
    {
      icon: "Target",
      title: "Source-Based Treatment",
      description: "We identify and treat the root cause of your pain, not just mask symptoms."
    },
    {
      icon: "Zap",
      title: "Non-Surgical Approach",
      description: "Advanced regenerative medicine eliminates the need for invasive surgery."
    },
    {
      icon: "Award",
      title: "Experienced Physicians",
      description: "Board-certified doctors with 14+ years specializing in regenerative medicine."
    },
    {
      icon: "Heart",
      title: "Personalized Care Plans",
      description: "Get you in. Get you better. Get you going. Every treatment is customized to you."
    }
  ]
};

export const conditions = [
  { name: "Back Pain", icon: "User", treatedCount: "2,500+" },
  { name: "Knee Pain", icon: "CircleDot", treatedCount: "1,800+" },
  { name: "Shoulder Pain", icon: "Move", treatedCount: "1,200+" },
  { name: "Arthritis", icon: "Activity", treatedCount: "3,000+" },
  { name: "Sports Injuries", icon: "Dumbbell", treatedCount: "1,500+" },
  { name: "Joint Pain", icon: "Circle", treatedCount: "2,800+" }
];

export const testimonials = [
  {
    id: 1,
    name: "Trust Doe",
    source: "Google Review",
    condition: "Patient",
    text: "The office is so clean! The staff have been phenomenal. Especially the doctors. Great bedside manners. I had so many questions, and they didn't act bothered. They actually smiled through my questions. I would highly recommend coming here.",
    rating: 5,
    image: null
  },
  {
    id: 2,
    name: "Renee Dennis",
    source: "Google Review",
    condition: "Patient",
    text: "I had a very nice experience with the ladies and gentleman of Atlanta Regenerative Medicine. The office was clean. The staff pleasant and my treatment went well.",
    rating: 5,
    image: null
  },
  {
    id: 3,
    name: "Precious Girggs",
    source: "Google Review",
    condition: "Car Accident Recovery",
    text: "After my car accident I was blessed to be referred to this pain management office. The doctors and nurses here explained in much detail how PRP was beneficial. After a few sessions my lower back is feeling much better and I highly recommend visiting.",
    rating: 5,
    image: null
  },
  {
    id: 4,
    name: "Nikita Howard",
    source: "Google Review",
    condition: "Patient",
    text: "The helpful staff at ATLREGEN are extremely caring and professional. They're a team of dedicated and compassionate individuals. I 10/10 recommend.",
    rating: 5,
    image: null
  },
  {
    id: 5,
    name: "Eddie Jackson",
    source: "Google Review",
    condition: "Pain Management",
    text: "I have been a patient for a few months and the Macon office is one of my favorite places to visit. Ms. Dee always has a smile on her face and is a very nice nurse. Jason always has a conversation for me and the Doctor is always informative. I thank y'all for all you've done with my pain.",
    rating: 5,
    image: null
  },
  {
    id: 6,
    name: "Verified Patient",
    source: "Vitals Review",
    condition: "Pain Treatment",
    text: "Dr. Cooper is kind, smart, and effective in treating my pain. I like that he has treatments other than medications. Amazing Dr. Great staff. He got right to the point and helped me recover from an injury.",
    rating: 5,
    image: null
  }
];

export const doctorInfo = {
  name: "Dr. Carroll D. Cooper",
  title: "Interventional Musculoskeletal Physiatrist",
  credentials: ["Board Certified in PM&R", "Board Certified in Electrodiagnostic Medicine"],
  quote: "My focus is on regenerative treatments for non-surgical orthopedic problems. Utilizing platelet rich plasma, stem cells, and traditional corticosteroids, I provide patients with non-surgical options for common orthopedic problems.",
  bio: "A native of Huntsville, Alabama, Dr. Carroll D. Cooper moved to Atlanta to attend Morehouse College. Following his time at Morehouse, Dr. Cooper obtained his medical degree from the University of Alabama-Birmingham School of Medicine. He did his residency training, in Physical Medicine and Rehabilitation, at the Medical College of Wisconsin. After finishing residency, he underwent additional training at The Hospital for Special Surgery, completing a fellowship in Interventional Spine and Sports Medicine.",
  image: "/webp-images/dr-carroll-cooper.webp",
  education: [
    "B.S. in Chemistry from Morehouse College",
    "M.D. from the University of Alabama School of Medicine",
    "Residency in Physical Medicine & Rehabilitation at Medical College of Wisconsin",
    "Fellowship in Interventional Spine & Sports Medicine from the Hospital for Special Surgery in New York City"
  ],
  accolades: [
    "NASA Scholar at Morehouse College",
    "Served as Chief Resident at the Medical College of Wisconsin",
    "Completed fellowship from the Hospital for Special Surgery in New York City",
    "Served as a team doctor for St. Peter's College in New Jersey"
  ],
  experience: "14+ Years",
  specialties: ["Regenerative Medicine", "Interventional Spine", "Sports Medicine"]
};

export const locations = [
  {
    id: 1,
    name: "Riverdale",
    address: "251 Medical Way",
    city: "Riverdale, GA 30274",
    phone: "(404) 355-2728",
    hours: "Mon-Fri: 8am-5pm",
    mapLink: "https://maps.app.goo.gl/u1sZ53XooYhbbABK8"
  },
  {
    id: 2,
    name: "Smyrna",
    address: "3656 Highlands Parkway SE",
    city: "Smyrna, GA 30082",
    phone: "(404) 355-2728",
    hours: "Mon-Fri: 8am-5pm",
    mapLink: "https://maps.app.goo.gl/5Hgt7rkuX8wqRpsz5"
  },
  {
    id: 3,
    name: "Decatur",
    address: "5243 Snapfinger Woods Dr",
    city: "Decatur, GA 30035",
    phone: "(404) 355-2728",
    hours: "Mon-Fri: 8am-5pm",
    mapLink: "https://maps.app.goo.gl/5jMMhGwTw62FewXX7"
  },
  {
    id: 4,
    name: "Macon",
    address: "3048 Napier Avenue, Suite B",
    city: "Macon, GA 31204",
    phone: "(404) 355-2728",
    hours: "Mon-Fri: 8am-5pm",
    mapLink: "https://maps.app.goo.gl/U8nUPfB1gib24v6p8"
  },
  {
    id: 5,
    name: "LaGrange",
    address: "1003 Hogansville Road, Suite A",
    city: "LaGrange, GA 30240",
    phone: "(404) 355-2728",
    hours: "Mon-Fri: 8am-5pm",
    mapLink: "https://maps.app.goo.gl/X3caFQULYRUdcrm79"
  },
  {
    id: 6,
    name: "Huntsville",
    address: "2933 Jordan Lane, N.W.",
    city: "Huntsville, AL 35816",
    phone: "(404) 355-2728",
    hours: "Mon-Fri: 8am-5pm",
    mapLink: "https://maps.app.goo.gl/CSyMnQKopyoimZbt8"
  }
];

export const finalCTA = {
  headline: "Ready to Live Pain-Free?",
  subheadline: "Book your appointment today and discover how regenerative medicine can transform your life.",
  primaryCTA: "Book an Appointment",
  secondaryCTA: "Call (404) 355-2728",
  trustPoints: [
    "Free Initial Consultation",
    "Same-Day Appointments Available",
    "6 Convenient Locations",
    "Insurance & Payment Plans Accepted"
  ]
};

export const contactInfo = {
  phone: "(404) 355-2728",
  fax: "(404) 662-2344",
  email: "info@atlregen.com",
  hours: "Monday - Friday: 8:00 AM - 5:00 PM",
  emergencyText: "Available 24/7"
};